exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntbody[data-v-21f64d60] {\n    display: block;\n    max-height: 20rem;\n    overflow-y: scroll;\n}\nthead[data-v-21f64d60],\ntbody tr[data-v-21f64d60],\ntfoot[data-v-21f64d60] {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n}\n.bg-has-value[data-v-21f64d60] {\n    background-color: lightyellow !important;\n}\n", ""]);

// exports
